import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface SidebarState {
    // State
    isCollapsed: boolean;

    // Actions
    toggleCollapsed: () => void;
    setCollapsed: (collapsed: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
    immer((set) => ({
        // State
        isCollapsed: false,

        // Actions
        toggleCollapsed: () =>
            set((state) => {
                state.isCollapsed = !state.isCollapsed;
            }),
        setCollapsed: (collapsed: boolean) =>
            set((state) => {
                state.isCollapsed = collapsed;
            }),
    }))
);
